module.exports = __webpack_public_path__ + "static/Texture2-8b9a9f59cc88a079a3cea6b92009d3f6.svg";